import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type Database = {
  public: {
    Tables: {
      devotionals: {
        Row: {
          id: string;
          day_of_year: number;
          title: string;
          content: string;
          scripture_reference: string | null;
          created_at: string;
        };
      };
      events: {
        Row: {
          id: string;
          title: string;
          description: string | null;
          event_type: 'meal' | 'program' | 'service' | 'other';
          day_of_week: number;
          time: string;
          location: string;
          created_at: string;
        };
      };
      donations: {
        Row: {
          id: string;
          amount: number;
          donor_name: string | null;
          donor_email: string | null;
          message: string | null;
          stripe_payment_id: string | null;
          status: 'pending' | 'completed' | 'failed';
          created_at: string;
        };
      };
      case_manager_bookings: {
        Row: {
          id: string;
          name: string;
          email: string;
          phone: string | null;
          message: string;
          preferred_contact_method: 'email' | 'phone';
          status: 'new' | 'contacted' | 'completed';
          created_at: string;
        };
      };
    };
  };
};
